import { createContext } from "react";

import { UserManagementActivationStatus } from "./types";

type ManageSlackAccessContextType = {
  activationStatus: UserManagementActivationStatus;
};

const ManageSlackAccessContext = createContext<ManageSlackAccessContextType | undefined>(undefined);

ManageSlackAccessContext.displayName = "ManageSlackAccessContext";

export default ManageSlackAccessContext;
